import { TWO_FACTOR_AUTH_INFO_STORAGE_KEY } from '@/contexts/AuthContext/constants';
import React, { PropsWithChildren } from 'react';
import { useLocation } from 'react-router';
import { Navigate } from 'react-router-dom';
import { useAuthContext } from '@/contexts/AuthContext';

const Authmiddleware = ({ children }: PropsWithChildren) => {
  const location = useLocation();
  const { authenticationInfo } = useAuthContext();

  if (!authenticationInfo) {
    return <Navigate to={{ pathname: '/login' }} state={{ from: { location } }} />;
  }
  return <React.Fragment>{children}</React.Fragment>;
};

export default Authmiddleware;
